import {Backdrop, CircularProgress, Typography} from '@mui/material';
import {TFunction} from 'i18next';

export default function UploadingImagesOverlay({isOpen, t}: {isOpen: boolean; t: TFunction}) {
  return (
    <Backdrop
      sx={{
        color: 'primary.main',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2
      }}
      open={isOpen}
    >
      <CircularProgress color="primary" size={56} />
      <Typography
        sx={{color: 'common.white', textAlign: 'center', fontSize: '1.25rem', px: 3}}
        fontWeight="bold"
      >
        {t('ui:uploadingWarning')}
      </Typography>
    </Backdrop>
  );
}
